import { Navigate, Route, Routes } from 'react-router-dom';
import routes from '@/routes.js';
import AcceptInvitePage from '@/screens/auth/pages/AcceptInvitePage.jsx';
import ForgotPasswordPage from '@/screens/auth/pages/ForgotPasswordPage.jsx';
import ResetPasswordPage from '@/screens/auth/pages/ResetPasswordPage.jsx';
import SignInPage from '@/screens/auth/pages/SignInPage.jsx';
import SignUpPage from '@/screens/auth/pages/SignUpPage.jsx';
import AssistantScreen from '@/screens/assistant/AssistantScreen.jsx';
import AutomationsScreen from '@/screens/automations/AutomationsScreen.jsx';
import ConnectionsScreen from '@/screens/connections/ConnectionsScreen.jsx';
import GalleryScreen from '@/screens/gallery/GalleryScreen.jsx';
import KnowledgeScreen from '@/screens/knowledge/KnowledgeScreen.jsx';
import OauthReturnScreen from '@/screens/oauthReturn/OauthReturnScreen.jsx';
import OnboardingScreen from '@/screens/onboarding/OnboardingScreen.jsx';
import SettingsScreen from '@/screens/settings/SettingsScreen.jsx';
import SkillsScreen from '@/screens/skills/SkillsScreen.jsx';
import AppShell from './appShell/AppShell.jsx';
import RouteGate from './RouteGate.jsx';

/** The screen drawn for each route id of routes.js. */
const SCREENS = {
  signIn: SignInPage,
  signUp: SignUpPage,
  forgotPassword: ForgotPasswordPage,
  resetPassword: ResetPasswordPage,
  acceptInvite: AcceptInvitePage,
  onboarding: OnboardingScreen,
  home: AssistantScreen,
  automations: AutomationsScreen,
  connections: ConnectionsScreen,
  skills: SkillsScreen,
  knowledge: KnowledgeScreen,
  settings: SettingsScreen,
  oauthReturn: OauthReturnScreen,
  gallery: GalleryScreen
};

const renderScreen = (routeId) => {
  const Screen = SCREENS[routeId];
  return <Screen />;
};

/** Routes of the web app. App sections share the signed-in shell; the rest stand alone. */
const PlatformRouter = () => {
  const appRoutes = routes.filter((route) => route.access === 'app');
  const standaloneRoutes = routes.filter((route) => route.access !== 'app');

  return (
    <Routes>
      {standaloneRoutes.map((route) => (
        <Route key={route.path} path={route.path} element={<RouteGate access={route.access}>{renderScreen(route.routeId)}</RouteGate>} />
      ))}
      <Route
        element={
          <RouteGate access="app">
            <AppShell />
          </RouteGate>
        }>
        {appRoutes.map((route) => (
          <Route key={route.path} path={route.path} element={renderScreen(route.routeId)} />
        ))}
      </Route>
      <Route path="/login" element={<Navigate to="/sign-in" replace />} />
      <Route path="/signup" element={<Navigate to="/sign-up" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default PlatformRouter;
